<template>
  <div id="app">
      <div v-if="snowflake" class="snowflakes" aria-hidden="true">
          <div class="snowflake">
              ❅
          </div>
          <div class="snowflake">
              ❅
          </div>
          <div class="snowflake">
              ❆
          </div>
          <div class="snowflake">
              ❄
          </div>
          <div class="snowflake">
              ❅
          </div>
          <div class="snowflake">
              ❆
          </div>
          <div class="snowflake">
              ❄
          </div>
          <div class="snowflake">
              ❅
          </div>
          <div class="snowflake">
              ❆
          </div>
          <div class="snowflake">
              ❄
          </div>
      </div>
      <!-- set progressbar -->
      <vue-progress-bar></vue-progress-bar>
     <transition name="fade">
        <router-view></router-view>
     </transition>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {},
  created(){
    this.addToBasket();
  },
    data() {
        return {
            snowflake:false,
        }
    },
    methods: {
        addToBasket: function () {
            setTimeout(() => {
                this.snowflake = false;
            }, 30000);
        }
    }
}
</script>

<style lang='sass'>
  $black: #9370DB
  $warning: #ffdd57
  $light: #ddd
  $section-padding: 1.5rem 1.5rem
  $modal-z: 200
  $modal-background-background-color: rgba(0, 0, 0, 0.4)
  @import '~bulma/bulma'
  @import '~bulma-badge'
  @import '~bulma-pricingtable'
  @import "~vue-swatches/dist/vue-swatches.min.css"
  @import '~bulma-tooltip'
  @import "~vue-multiselect/dist/vue-multiselect.min.css"
</style>
<style lang='scss'>

.snowflake {
    color: #fff;
    font-size: 1em;
    font-family: Arial;
    text-shadow: 0 0 1px #000;
}

@-webkit-keyframes snowflakes-fall{0%{top:-10%}100%{top:100%}}@-webkit-keyframes snowflakes-shake{0%{-webkit-transform:translateX(0px);transform:translateX(0px)}50%{-webkit-transform:translateX(80px);transform:translateX(80px)}100%{-webkit-transform:translateX(0px);transform:translateX(0px)}}@keyframes snowflakes-fall{0%{top:-10%}100%{top:100%}}@keyframes snowflakes-shake{0%{transform:translateX(0px)}50%{transform:translateX(80px)}100%{transform:translateX(0px)}}.snowflake{position:fixed;top:-10%;z-index:9999;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default;-webkit-animation-name:snowflakes-fall,snowflakes-shake;-webkit-animation-duration:10s,3s;-webkit-animation-timing-function:linear,ease-in-out;-webkit-animation-iteration-count:infinite,infinite;-webkit-animation-play-state:running,running;animation-name:snowflakes-fall,snowflakes-shake;animation-duration:10s,3s;animation-timing-function:linear,ease-in-out;animation-iteration-count:infinite,infinite;animation-play-state:running,running}.snowflake:nth-of-type(0){left:1%;-webkit-animation-delay:0s,0s;animation-delay:0s,0s}.snowflake:nth-of-type(1){left:10%;-webkit-animation-delay:1s,1s;animation-delay:1s,1s}.snowflake:nth-of-type(2){left:20%;-webkit-animation-delay:6s,.5s;animation-delay:6s,.5s}.snowflake:nth-of-type(3){left:30%;-webkit-animation-delay:4s,2s;animation-delay:4s,2s}.snowflake:nth-of-type(4){left:40%;-webkit-animation-delay:2s,2s;animation-delay:2s,2s}.snowflake:nth-of-type(5){left:50%;-webkit-animation-delay:8s,3s;animation-delay:8s,3s}.snowflake:nth-of-type(6){left:60%;-webkit-animation-delay:6s,2s;animation-delay:6s,2s}.snowflake:nth-of-type(7){left:70%;-webkit-animation-delay:2.5s,1s;animation-delay:2.5s,1s}.snowflake:nth-of-type(8){left:80%;-webkit-animation-delay:1s,0s;animation-delay:1s,0s}.snowflake:nth-of-type(9){left:90%;-webkit-animation-delay:3s,1.5s;animation-delay:3s,1.5s}

@font-face { font-family: Pfdintextpro; src: url('./assets/fonts/pfdintextpro-regular.ttf'); }
@font-face { font-family: Pfdintextpro; font-weight: bold; src: url('./assets/fonts/pfdintextpro-bold.ttf'); }
@font-face { font-family: Pfdintextpro;  font-weight: 100; src: url('./assets/fonts/pfdintextpro-thin.ttf'); }

.clickable{
    cursor: pointer;
    transition: all .2s ease-in-out;
}



@-webkit-keyframes bell-shake {
    1% { -webkit-transform: rotateZ(15deg); transform-origin: 50% 0%; }
    2% { -webkit-transform: rotateZ(-15deg); transform-origin: 50% 0%;}
    3% { -webkit-transform: rotateZ(20deg); transform-origin: 50% 0%; }
    4% { -webkit-transform: rotateZ(-20deg); transform-origin: 50% 0%;}
    5% { -webkit-transform: rotateZ(15deg); transform-origin: 50% 0%; }
    6% { -webkit-transform: rotateZ(-15deg); transform-origin: 50% 0%;}
    7% { -webkit-transform: rotateZ(0); transform-origin: 50% 0%;   }
    100% { -webkit-transform: rotateZ(0); transform-origin: 50% 0%;  }
}

@-moz-keyframes bell-shake {
    1% { -moz-transform: rotateZ(15deg); transform-origin: 50% 0%; }
    2% { -moz-transform: rotateZ(-15deg); transform-origin: 50% 0%;}
    3% { -moz-transform: rotateZ(20deg); transform-origin: 50% 0%; }
    4% { -moz-transform: rotateZ(-20deg); transform-origin: 50% 0%;}
    5% { -moz-transform: rotateZ(15deg); transform-origin: 50% 0%; }
    6% { -moz-transform: rotateZ(-15deg); transform-origin: 50% 0%;}
    7% { -moz-transform: rotateZ(0); transform-origin: 50% 0%;   }
    100% { -moz-transform: rotateZ(0); transform-origin: 50% 0%;  }
}

@keyframes bell-shake {
    1% { transform: rotateZ(15deg); transform-origin: 50% 0%; }
    2% { transform: rotateZ(-15deg); transform-origin: 50% 0%;}
    3% { transform: rotateZ(20deg); transform-origin: 50% 0%; }
    4% { transform: rotateZ(-20deg); transform-origin: 50% 0%;}
    5% { transform: rotateZ(15deg); transform-origin: 50% 0%; }
    6% { transform: rotateZ(-15deg); transform-origin: 50% 0%;}
    7% { transform: rotateZ(0); transform-origin: 50% 0%;   }
    100% { transform: rotateZ(0); transform-origin: 50% 0%;   }
}

/* Bell shake */
.bell-shake--hover:hover,
.bell-shake--hover:focus,
.bell-shake {
    -webkit-animation: bell-shake 10s ease infinite;
    -moz-animation: bell-shake 10s ease infinite;
    animation: bell-shake 10s ease infinite;
}

.bell-shake-delay {
    -webkit-animation: bell-shake 10s ease 3s infinite;
    -moz-animation: bell-shake 10s ease 3s infinite;
    animation: bell-shake 10s ease 3s infinite;
}


.blink_after::after {
    animation: blinker 1s linear infinite;
}

.blink_me {
    animation: blinker 1s linear infinite;
}

@keyframes blinker {
    50% { opacity: 0; }
}

.clickable:hover { transform: scale(1.05); z-index: 100 }

html{
    background-color: #f5f5f5;
}
body{
    font-family: 'Pfdintextpro' !important;
}

body :not(p, .help, .heading, .title){
    font-weight: 300;
}

button, select, textarea, .subtitle  {
    font-weight: 300 !important;
    font-family: 'Pfdintextpro', sans-serif !important;
    /* font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif; */
}

input{
    font-family: 'Pfdintextpro', sans-serif !important;
}
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    font-weight: 300;
}
::-moz-placeholder { /* Firefox 19+ */
    font-weight: 300;
}
:-ms-input-placeholder { /* IE 10+ */
    font-weight: 300;
}
:-moz-placeholder { /* Firefox 18- */
    font-weight: 300;
}

.help, .heading{
    font-weight: normal !important;
}

.fix-footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 5;
    overflow:hidden;
}

.footer{
    background-color: #3D4351;
    color: white !important;
    padding: 0.5rem 0.5rem 0.5rem;
}

.footer a{
    margin: 5px;
    color: white !important;
}

.footer p{
    margin-top: 15px;    
}

.background-sky{
    background-color: #F2F6FA;
}

img.round{
    border-radius: 50%;
}

#app {
    font-family: 'Pfdintextpro';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.box{
    background-color: white;
    margin:5px;
}

.box:not(:last-child) {
    margin-bottom: 5px;
}

.v-toaster .v-toast{
    font-family: 'Pfdintextpro';
}

.iziToast.iziToast-color-green{
    background-color: #00b89c !important;
}

.iziToast.iziToast-color-red{
    background-color: #ff3860 !important;
}

.iziToast.iziToast-color-blue{
    background-color: #3273dc !important;
}

.v-toaster .v-toast.v-toast-error {
  background-color: #ff3860 !important;;
}

.v-toaster .v-toast.v-toast-success {
  background-color: #00b89c !important;
}

.fa-facebook, .fa-facebook-square, .fa-facebook-official {
    color: #3b5998
}

.fa-google-plus, .fa-google-plus-square, .fa-google-plus-official {
    color: #dd4b39
}

.avatar .logo {
  background: #fff;
  height: 75px !important;
  max-height: 150px !important;
}

.fade-fast-enter-active, .fade-fast-leave-active {
  transition-property: opacity;
  transition-duration: .1s;
}

.fade-fast-enter-active {
  transition-delay: .1s;
}

.fade-fast-enter, .fade-fast-leave-active {
  opacity: 0
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.scroll-y{
    overflow-y: auto;
    overflow-x: visible;
    height: 918px;
    padding-left: 30px;
    padding-right: 30px;
}

.card .content, .card .content h4 {
    margin-bottom: 0px;
}

.zero-horizontal-padding{
    padding-left:0px !important;
    padding-right:0px !important;;
}

.zero-vertical-padding{
    padding-top:0px !important;;
    padding-bottom:0px !important;;
}

.zero-vertical-margin{
    margin-top:0px !important;;
    margin-bottom:0px !important;;
}

.minimal-horizontal-padding{
    padding-left:2px !important;
    padding-right:2px !important;;
}

.minimal-vertical-padding{
    padding-top:2px !important;;
    padding-bottom:2px !important;;
}

.minimal-vertical-margin{
    margin-top:2px !important;;
    margin-bottom:2px !important;;
}

.multiline-text{
    word-break: break-word !important;
    white-space: normal  !important;;
    height: auto  !important;;
    max-width: 96%  !important;;
}

.width-fill-available{
    width: -webkit-fill-available;
}

/* Wrapper */
.icon-button {
    background-color: white;
    border-radius: 3.6rem;
    cursor: pointer;
    display: inline-block;
    font-size: 1.8rem;
    height: 3.6rem;
    line-height: 3.6rem;
    margin: 0 5px;
    position: relative;
    text-align: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 3.6rem;
}

/* Circle */
.icon-button span {
    border-radius: 0;
    display: block;
    height: 0;
    left: 50%;
    margin: 0;
    position: absolute;
    top: 50%;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 0;
}
.icon-button:hover span {
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 3.6rem;
    margin: -1.8rem;
}

/* Icons */
.icon-button i {
    background: none;
    color: white;
    height: 3.6rem;
    left: 0;
    line-height: 3.6rem;
    position: absolute;
    top: 0;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 3.6rem;
    z-index: 10;
}

.twitter span {
    background-color: #4099ff;
}
.facebook span {
    background-color: #3B5998;
}
.google-plus span {
    background-color: #db5a3c;
}
.tumblr span {
    background-color: #34526f;
}
.instagram span {
    background-color: #517fa4;
}
.youtube span {
    background-color: #bb0000;
}
.pinterest span {
    background-color: #cb2027;
}
.linkedin span {
    background-color: #0073B0;
}

.icon-button .icon-linkedin {
    color: #0073B0;
}

.icon-button .icon-twitter {
    color: #4099ff;
}
.icon-button .icon-facebook {
    color: #3B5998;
}
.icon-button .fa-tumblr {
    color: #34526f;
}
.icon-button .icon-google-plus {
    color: #db5a3c;
}
.icon-button .fa-instagram {
    color: #517fa4;
}
.icon-button .fa-youtube {
    color: #bb0000;
}
.icon-button .icon-pinterest {
    color: #cb2027;
}

.icon-button:hover .icon-twitter,
.icon-button:hover .icon-facebook,
.icon-button:hover .icon-google-plus,
.icon-button:hover .icon-linkedin,
.icon-button:hover .fa-tumblr,
.icon-button:hover .fa-instagram,
.icon-button:hover .fa-youtube,
.icon-button:hover .fa-linkedin-in,
.icon-button:hover .icon-pinterest {
    color: white;
}

.vue-swatches__trigger{
    border: 1px solid #ccc;
}

.p5{
    padding: 5px;
}


::-webkit-scrollbar {
        width: 7px;
        height: 7px;
    }
::-webkit-scrollbar-track {
        background: #fff;
        -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
    }
::-webkit-scrollbar-thumb {
        background: #ccc;
        -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.2);
        border-radius: 8px;
    }
::-webkit-scrollbar-thumb:hover {
        background: #aaa;
        border-radius: 8px;
        cursor: pointer;
    }
::-webkit-scrollbar-thumb:active {
        background: #888;
        -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.3);
        border-radius: 8px;
        cursor: pointer;
    }

@media all and (max-width: 680px) {
    .icon-button {
        border-radius: 1.6rem;
        font-size: 0.8rem;
        height: 1.6rem;
        line-height: 1.6rem;
        width: 1.6rem;
    }

    .icon-button:hover span {
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 1.6rem;
        margin: -0.8rem;
    }

    /* Icons */
    .icon-button i {
        height: 1.6rem;
        line-height: 1.6rem;
        width: 1.6rem;
    }
    body {

        padding: 10px;
    }
    .pinterest {
        display: none;
    }

}

</style>



// WEBPACK FOOTER //
// src/App.vue